import React__default from 'react';
import { ArticlePromo } from '../article-promo/article-promo.esm.js';
import '@costar-ui/cosmos';
import { ArticleTitle } from '../atoms/article-title/article-title.esm.js';
import { CategoryBar } from '../atoms/category-bar/category-bar.esm.js';

var ArticleWithFeaturedAuthor = function ArticleWithFeaturedAuthor(_ref) {
  var articleTitleElement = _ref.articleTitleElement,
    categoryBarElement = _ref.categoryBarElement,
    contactCard = _ref.contactCard;
  var articleTitle_ = /*#__PURE__*/React__default.createElement(ArticleTitle, {
    className: "text-[22px]/[27px]"
  }, articleTitleElement);
  var categoryBarElement_ = /*#__PURE__*/React__default.createElement(CategoryBar, null, categoryBarElement);
  return /*#__PURE__*/React__default.createElement("article", {
    className: "flex flex-col gap-y-2"
  }, /*#__PURE__*/React__default.createElement(ArticlePromo, {
    articleTitleElement: articleTitle_,
    categoryBarElement: categoryBarElement_
  }), contactCard);
};

export { ArticleWithFeaturedAuthor };
//# sourceMappingURL=article-with-featured-author.esm.js.map
